<template>
  <div class="invoicerow">
    <div class="column cupon">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15" height="15"><path fill="none" d="M0 0h24v24H0z"/><path d="M14 3v18H3a1 1 0 0 1-1-1v-5.5a2.5 2.5 0 1 0 0-5V4a1 1 0 0 1 1-1h11zm2 0h5a1 1 0 0 1 1 1v5.5a2.5 2.5 0 1 0 0 5V20a1 1 0 0 1-1 1h-5V3z" fill="rgba(0,64,255,1)"/></svg>
      <p class="user" :title="code">{{ code }}</p>
    </div>
    <div v-if="!isMobile()" class="column beneficiario">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15" height="15"><path fill="none" d="M0 0h24v24H0z"/><path d="M1 22a8 8 0 1 1 16 0H1zm8-9c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6zm9.246-9.816A9.97 9.97 0 0 1 19 7a9.97 9.97 0 0 1-.754 3.816l-1.677-1.22A7.99 7.99 0 0 0 17 7a7.99 7.99 0 0 0-.43-2.596l1.676-1.22zm3.302-2.4A13.942 13.942 0 0 1 23 7c0 2.233-.523 4.344-1.452 6.216l-1.645-1.196A11.955 11.955 0 0 0 21 7c0-1.792-.393-3.493-1.097-5.02L21.548.784z" fill="rgba(0,64,255,1)"/></svg>
      <p class="money" :title="userName(email)">{{ userName(email) }} </p>
    </div>
    <div v-if="!isMobile()" class="column creacion">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15" height="15"><path fill="none" d="M0 0h24v24H0z"/><path d="M9 1v2h6V1h2v2h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4V1h2zm11 7H4v11h16V8zm-4.964 2.136l1.414 1.414-4.95 4.95-3.536-3.536L9.38 11.55l2.121 2.122 3.536-3.536z" fill="rgba(0,64,255,1)"/></svg>
      <p class="money">{{ humanTime(ctime) }}</p>
    </div>
    <div v-if="!isMobile()" class="column canjeo">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15" height="15"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-13H8v2h9l-5-5v3zm-5 4l5 5v-3h4v-2H7z" fill="rgba(0,64,255,1)"/></svg>
      <p class="money">{{ humanTime(utime) }}</p>
    </div>
    <div v-if="isMobile()" class="column info">
      <button @click="isShow = true" :aria-label="$t('buttons.moreInformation')" :title="$t('buttons.moreInformation')" class="action" id="info-button">
        <info-icon size="1.5x" class="custom-class"></info-icon>
      </button>
      <div class="information" :style="infoStyle">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
          <h3>{{ $t('dealers.couponInformation') }}</h3>
          <x-icon @click="isShow = false" size="1.5x" class="custom-class"></x-icon>
        </div>
        <div class="column">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15" height="15"><path fill="none" d="M0 0h24v24H0z"/><path d="M14 3v18H3a1 1 0 0 1-1-1v-5.5a2.5 2.5 0 1 0 0-5V4a1 1 0 0 1 1-1h11zm2 0h5a1 1 0 0 1 1 1v5.5a2.5 2.5 0 1 0 0 5V20a1 1 0 0 1-1 1h-5V3z" fill="rgba(0,64,255,1)"/></svg>
          <p class="user" :title="code">{{ code }}</p>
        </div>
        <div class="column">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15" height="15"><path fill="none" d="M0 0h24v24H0z"/><path d="M1 22a8 8 0 1 1 16 0H1zm8-9c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6zm9.246-9.816A9.97 9.97 0 0 1 19 7a9.97 9.97 0 0 1-.754 3.816l-1.677-1.22A7.99 7.99 0 0 0 17 7a7.99 7.99 0 0 0-.43-2.596l1.676-1.22zm3.302-2.4A13.942 13.942 0 0 1 23 7c0 2.233-.523 4.344-1.452 6.216l-1.645-1.196A11.955 11.955 0 0 0 21 7c0-1.792-.393-3.493-1.097-5.02L21.548.784z" fill="rgba(0,64,255,1)"/></svg>
          <p class="money" :title="userName(email)">{{ userName(email) }} </p>
        </div>
        <div class="column">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15" height="15"><path fill="none" d="M0 0h24v24H0z"/><path d="M9 1v2h6V1h2v2h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4V1h2zm11 7H4v11h16V8zm-4.964 2.136l1.414 1.414-4.95 4.95-3.536-3.536L9.38 11.55l2.121 2.122 3.536-3.536z" fill="rgba(0,64,255,1)"/></svg>
          <p class="money">{{ humanTime(ctime) }}</p>
        </div>
        <div class="column">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15" height="15"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-13H8v2h9l-5-5v3zm-5 4l5 5v-3h4v-2H7z" fill="rgba(0,64,255,1)"/></svg>
          <p class="money">{{ humanTime(utime) }}</p>
        </div>
      </div>
    </div>
    <div class="column delete">
      <button @click="$emit('delete', id, email)" :aria-label="$t('buttons.delete')" :title="$t('buttons.delete')" class="button button--red" id="delete-button">
        <trash-2-icon size="1.5x" class="custom-class"></trash-2-icon>
        <span v-if="!isMobile()">{{ $t('buttons.delete') }}</span>
      </button>
    </div>
  </div>
</template>

<script>

import { Trash2Icon, InfoIcon, XIcon } from 'vue-feather-icons';
import moment from 'moment';

export default {
  name: 'coupon',
  components: {
    Trash2Icon,
    InfoIcon,
    XIcon,
},
  data: function () {
    return {
      isShow: false
    };
  },
  props: ['code', 'email', 'ctime', 'utime' , 'id', 'handle'],
  computed: {
    infoStyle () {
      if (this.isShow) {
        return {display: 'block'};
      } else {
        return {display: 'none'};
      }
    },
  },
  methods: {
    isMobile: function () {
      return window.innerWidth <= 768;
    },
    humanTime: function (time) {
      if (time === 0) {
        return '-';
      } else {
        return moment(time * 1000).format('DD/MM/YYYY');
      }
    },
    userName: function (email) {
      if (email === '') {
        return 'Sin beneficiario';
      } else {
        return email;
      }
    },
  }
};
</script>